export const selectCheckout = ($) => $?.checkout ?? null;

export const selectCheckoutPos = ($) => $?.checkout?.pos ?? null;
export const selectCheckoutClientId = ($) => $?.checkout?.clientId ?? null;
export const selectCheckoutBookingData = ($) => $?.checkout?.bookingData ?? null;
export const selectCheckoutSelectedAppointment = ($) => $?.checkout?.selectedAppointment ?? null;
export const selectCheckoutPaymentOption = ($) => $?.checkout?.selectedPaymentOption ?? null;
export const selectCheckoutTxLog = ($) => $?.checkout?.transactionLog ?? null;

export const selectCheckoutIsFetching = ($) => $?.checkout?.isFetching ?? null;
export const selectCheckoutInitialDeposit = ($) => $?.checkout?.initialDeposit ?? null;
export const selectCheckoutDepositListSuccess = ($) => $?.checkout?.depositClientListSuccess ?? null;
export const selectCheckoutDepositUnlock = ($) => $?.checkout?.depositUnlock ?? null;

export const selectCheckoutData = ($) => $?.checkout?.data ?? null;
export const selectCheckoutDataSalonTaxesAndFees = ($) => $?.checkout?.data?.salonTaxesAndFees ?? null;
export const selectCheckoutDataCods = ($) => $?.checkout?.data?.deposits?.clientsOutstandingDeposits ?? null;
export const selectCheckoutDataVouchersUsed = ($) => $?.checkout?.data?.vouchers_used ?? null;

export const selectCheckoutFinishUrl = ($) => $?.checkout?.finishUrl;
export const selectCheckoutAppointments = ($) => $?.checkout?.appointments;
export const selectCheckoutChargingCardError = ($) => $?.checkout?.chargingCardError;
export const selectCheckoutCardOnFileChargeSuccess = ($) => $?.checkout?.cardOnFileChargeSuccess;
